/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsinvoicevat2Inputs */

const en_ticketsinvoicevat2 = /** @type {(inputs: Ticketsinvoicevat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VAT on tickets`)
};

const de_ticketsinvoicevat2 = /** @type {(inputs: Ticketsinvoicevat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umsatzsteuer auf Tickets`)
};

/**
* | output |
* | --- |
* | "VAT on tickets" |
*
* @param {Ticketsinvoicevat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsinvoicevat2 = /** @type {((inputs?: Ticketsinvoicevat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsinvoicevat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsinvoicevat2(inputs)
	return de_ticketsinvoicevat2(inputs)
});
export { ticketsinvoicevat2 as "ticketsInvoiceVat" }